// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationES from "./locales/es/translation.json";
import translationCA from "./locales/ca/translation.json";

const resources = {
  es: {
    translation: translationES,
  },
  ca: {
    translation: translationCA,
  },
};

const SUPPORTED_LANGUAGES = ["es", "ca"];

const getInitialLanguage = () => {
  const stored = localStorage.getItem("appLanguage");
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
    return stored;
  }

  const browserLang = (navigator.language || "es").slice(0, 2).toLowerCase();
  return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : "es";
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "es",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("appLanguage", lng);
  document.documentElement.setAttribute("lang", lng);
});

document.documentElement.setAttribute("lang", i18n.language);

export default i18n;
